import { send_to_server } from '@/services/socketio_client_react/send_to_server';
import { ActionReducerMapBuilder, PayloadAction } from '@reduxjs/toolkit';
import { DTO_RESPONSE__error } from '@shared/network/DTO_RESPONSE__error';
import { DTO_RESPONSE__success } from '@shared/network/DTO_RESPONSE__success';
import { ENUM__network_event_client_to_server } from '@shared/network/ENUM__network_event_client_to_server';
import { createAsyncThunkSafe } from '../../../_base/createAsyncThunkSafe';
import { STATE__generation } from '../../STATE__generation';

export const remote_user_task_get_shared_by_generation_id = createAsyncThunkSafe<DTO_RESPONSE__success | DTO_RESPONSE__error, string>(
  ENUM__network_event_client_to_server.USER_TASK_GET_SHARED_BY_GENERATION_ID,
  async (user_task_id, thunkApi): Promise<DTO_RESPONSE__success | DTO_RESPONSE__error> => {
    return await send_to_server<DTO_RESPONSE__success | DTO_RESPONSE__error>(
      ENUM__network_event_client_to_server.USER_TASK_GET_SHARED_BY_GENERATION_ID,
      user_task_id,
    );
  },
);

export function init_remote_user_task_get_shared_by_generation_id(builder: ActionReducerMapBuilder<STATE__generation>) {
  builder
    .addCase(remote_user_task_get_shared_by_generation_id.pending, state => {})
    .addCase(remote_user_task_get_shared_by_generation_id.rejected, (state, action) => {})
    .addCase(remote_user_task_get_shared_by_generation_id.fulfilled, (state, action: PayloadAction<DTO_RESPONSE__success | DTO_RESPONSE__error>) => {});
}
